import React, { useState } from "react";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Button from "react-multi-date-picker/components/button";

const PersianDateTimePicker = ({
  type,
  defaultTime,
  minTime,
  maxTime,
  setStateFunction,
}) => {
  // Convert defaultTime, minTime, maxTime into Date objects if they're not already
  const formattedDefaultTime =
    defaultTime instanceof Date ? defaultTime : new Date(defaultTime || "");
  const formattedMinTime =
    minTime instanceof Date ? minTime : new Date(minTime || "");
  const formattedMaxTime =
    maxTime instanceof Date ? maxTime : new Date(maxTime || "");

  const handleDateChange = (newDate) => {
    if (newDate) {
      setStateFunction(newDate.toDate()); // Convert DateObject to native Date
      setTemporaryDate(newDate.toDate());
    } else {
      setStateFunction(null); // Handle null case
    }
  };

  const [temporaryDate, setTemporaryDate] = useState(defaultTime);

  return (
    <div>
      <DatePicker
        name={type}
        calendar={persian}
        locale={persian_fa}
        calendarPosition="bottom-right"
        hideOnScroll
        value={temporaryDate}
        minDate={formattedMinTime}
        maxDate={formattedMaxTime}
        format="DD/MM/YYYY HH:mm:ss"
        plugins={[<TimePicker position="bottom" />]}
        onChange={handleDateChange}
        render={
          <Button className="text-light bg-dark rounded px-3 py-2 border border-secondary focus-outline-none focus-ring" />
        }
      />
    </div>
  );
};

export default PersianDateTimePicker;
